import { StandingItem } from '@/services/mabarService';

interface StandingCardProps {
  standings: StandingItem[];
}

export const getTeamDotColorClass = (name?: string): string => {
  const n = (name || '').toLowerCase();
  if (n.includes('green') || n.includes('hijau')) return 'bg-team-green';
  if (n.includes('navy') || n.includes('biru')) return 'bg-team-navy';
  if (n.includes('orange') || n.includes('jingga')) return 'bg-team-orange';
  if (n.includes('red') || n.includes('merah')) return 'bg-team-red';
  if (n.includes('yellow') || n.includes('kuning')) return 'bg-team-yellow';
  return 'bg-team-orange';
};

export default function StandingCard({ standings }: StandingCardProps) {
  return (
    <div className="bg-white rounded-2xl border border-[#E0E6ED] shadow-2xs overflow-hidden w-full">
      <div className="w-full">
        <table className="w-full text-xs text-left table-fixed">
          <thead>
            <tr className="border-b border-[#F0F2F4] bg-[#FAFBFC] text-[11px] font-bold text-[#8C8C8C] uppercase tracking-wider">
              <th className="py-3 px-3 text-center w-8">#</th>
              <th className="py-3 px-2">TIM</th>
              <th className="py-3 px-1 text-center w-8">M</th>
              <th className="py-3 px-1 text-center w-8">W</th>
              <th className="py-3 px-1 text-center w-8">S</th>
              <th className="py-3 px-1 text-center w-8">K</th>
              <th className="py-3 px-1 text-center w-8">P</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F0F2F4]">
            {standings.length > 0 ? (
              standings.map((item, index) => {
                const rank = item.position || index + 1;
                const isFirst = rank === 1;
                const dotColorClass = getTeamDotColorClass(item.team);

                return (
                  <tr
                    key={item.team}
                    className="transition-colors bg-white hover:bg-gray-50/50"
                  >
                    {/* Rank */}
                    <td className="py-3 px-3 text-center">
                      <span
                        className={`font-extrabold text-sm ${
                          isFirst ? 'text-[#FC480D]' : 'text-[#0E1726]'
                        }`}
                      >
                        {rank}
                      </span>
                    </td>

                    {/* Team Dot & Name */}
                    <td className="py-3 px-2 min-w-0">
                      <div className="flex items-center gap-2 min-w-0">
                        <span
                          className={`w-2 h-2 rounded-full shrink-0 ${dotColorClass}`}
                        />
                        <span
                          title={item.team}
                          className="text-sm font-bold text-[#0E1726] truncate block min-w-0 flex-1"
                        >
                          {item.team}
                        </span>
                      </div>
                    </td>

                    {/* Stats Columns: M, W, S, K, P */}
                    <td className="py-3 px-1 text-center text-[#0E1726] font-semibold text-sm">
                      {item.matches_played}
                    </td>
                    <td className="py-3 px-1 text-center text-[#0E1726] font-semibold text-sm">
                      {item.wins}
                    </td>
                    <td className="py-3 px-1 text-center text-[#0E1726] font-semibold text-sm">
                      {item.draws}
                    </td>
                    <td className="py-3 px-1 text-center text-[#0E1726] font-semibold text-sm">
                      {item.losses}
                    </td>
                    <td className="py-3 px-1 text-center text-[#FC480D] font-extrabold text-sm">
                      {item.points}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="py-8 text-center text-gray-400 text-xs font-medium">
                  Belum ada data klasemen
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Legend Footer */}
      <div className="px-4 py-3 bg-white border-t border-[#F0F2F4] flex items-center gap-3 text-xs text-[#8C8C8C] font-medium flex-wrap">
        <span>M · Main</span>
        <span>W · Menang</span>
        <span>S · Seri</span>
        <span>K · Kalah</span>
        <span>P · Poin</span>
      </div>
    </div>
  );
}
